import { Component, OnInit } from '@angular/core';
import { DetailsModalService } from '../../services/details-modal.service';
import { HeaderModel } from '../../models/header.model';
import { ICartDetails } from '../../interfaces/cart-details.interface';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { CartClearConfirmationService } from '../../services/cart-clear-confirmation.service';
import { LogoutModalService } from '../../services/logoutModalService';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';
import CustomerDetailsService from '../../cart-process/customer-details.service';

@Component({
  selector: 'new-offer-header',
  templateUrl: './new-offer-header.component.html',
  providers: [
    DetailsModalService
  ]
})
export class NewOfferHeaderComponent implements OnInit {
  public headerData: HeaderModel;
  public isVirginBrand: boolean;

  constructor(
    public commonInfo: CommonInfoService,
    private logoutModalService: LogoutModalService,
    private detailsModalService: DetailsModalService,
    private cartClearConfirmationService: CartClearConfirmationService,
    private commonModalService: CommonModalService,
    private notificationProvider: NotificationProviderService,
    protected customerDetailsService: CustomerDetailsService,
  ) {
  }

  ngOnInit(): void {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.headerData = new HeaderModel(cartDetails);
      }
    });

    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  public contractDetailsModalShow($event: Event): void {
    $event.preventDefault();

    const el = $event.target as HTMLElement;

    this.detailsModalService.showContractDetails(el);
  }

  public informationOnLimitsModalShow($event: Event): void {
    $event.preventDefault();

    let modalData = {
      templateName: CommonModalTemplatesEnum.INFORMATION_ON_LIMITS,
    };

    this.commonModalService.setData(modalData);
  }

  public showLogoutModal($event: Event): void {
    $event.preventDefault();

    this.logoutModalService.showModal();
  }

  public cartClearConfirmationModal($event: Event): void {
    $event.preventDefault();

    this.cartClearConfirmationService.cartClear();
  }
}
